import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const reportSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const reportHeading = css({
  fontSize: 'body-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const reportDescription = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
  lineHeight: 'body-sm',
});

export const reportLink = css({
  fontSize: 'body-sm',
  fontWeight: 'regular',
  color: 'brand.primary',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: '0',
  textAlign: 'left',
  _hover: {
    color: 'brand.primaryHover',
    textDecoration: 'underline',
  },
});

export const actionRow = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
});

export const separator = css({
  fontSize: 'body-sm',
  color: 'text.subtle',
});
